"use client"
import type { ReactNode } from "react"
import { useWebview } from "@/vendors/webview/context/webview-client.context"

type PlatformProps = {
  readonly web: ReactNode
  readonly app: ReactNode
}

export function PlatformSwitch({ web, app }: PlatformProps) {
  const { isWebview } = useWebview()

  return isWebview ? app : web
}
